"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { Box, DialogActions } from "@mui/material";
import { Button } from "../../Inputs/Button/index.js";
import { ModalCloseButton } from "./ModalCloseButton/index.js";
import { INVALID_PROPS_ERROR, COMPONENT_NAME } from "./constants.js";
import { Dialog, dialogHeadingWrapperStyles, StyledText, DialogContent, StyledButtonContainer } from "./styles.js";
import { MODAL_HEADING_ID } from "./types.js";
import { getDataTestId } from "../../Util/index.js";
const Modal = (props) => {
  const {
    closeAriaLabel,
    onClose,
    isOpen,
    id,
    modalTitle,
    hideBackdrop = false,
    hideCloseButton = false,
    role = "dialog",
    buttons,
    children,
    uniqueId,
    sx,
    scroll,
    paperProps
  } = props;
  const modalRef = useRef();
  const isRenderedRef = useRef(false);
  const isPaperScroll = scroll === "paper";
  const handleModalContentRef = (node) => {
    if (node && !(isRenderedRef == null ? void 0 : isRenderedRef.current)) {
      modalRef.current = node;
      isRenderedRef.current = true;
      const paperContainer = modalRef.current.querySelector('[role="dialog"]');
      paperContainer == null ? void 0 : paperContainer.focus();
    }
  };
  useEffect(() => {
    return () => {
      isRenderedRef.current = false;
    };
  }, [isOpen]);
  if (!modalTitle || !onClose) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      id,
      open: isOpen,
      onClose,
      hideBackdrop,
      scroll: scroll ?? "body",
      PaperProps: {
        role,
        tabIndex: -1,
        ...paperProps
      },
      "aria-labelledby": MODAL_HEADING_ID,
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      ref: handleModalContentRef,
      sx,
      "aria-modal": true,
      children: [
        /* @__PURE__ */ jsxs(Box, { sx: dialogHeadingWrapperStyles, children: [
          /* @__PURE__ */ jsx(StyledText, { id: MODAL_HEADING_ID, component: "h2", children: modalTitle }),
          hideCloseButton ? null : /* @__PURE__ */ jsx(
            ModalCloseButton,
            {
              ariaLabel: closeAriaLabel,
              onClose
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          DialogContent,
          {
            "aria-labelledby": isPaperScroll ? MODAL_HEADING_ID : void 0,
            tabIndex: isPaperScroll ? 0 : void 0,
            role: isPaperScroll ? "region" : void 0,
            children
          }
        ),
        (buttons ?? []).length > 0 && /* @__PURE__ */ jsx(DialogActions, { sx: { padding: "8px 16px 16px 16px" }, children: /* @__PURE__ */ jsx(StyledButtonContainer, { isOneBtn: (buttons == null ? void 0 : buttons.length) === 1, children: buttons == null ? void 0 : buttons.slice(0, 2).map((button, i) => {
          const { action, href, isLoading, text, target } = button;
          const buttonType = i === 1 ? "secondary" : "primary";
          return /* @__PURE__ */ jsx(
            Button,
            {
              onClick: (e) => action == null ? void 0 : action(e),
              variant: buttonType,
              href,
              target,
              isLoading,
              uniqueId: `${uniqueId}_${buttonType}`,
              children: text
            },
            uniqueId + buttonType
          );
        }) }) })
      ]
    }
  );
};
Modal.displayName = COMPONENT_NAME;
export {
  Modal
};
